<template>
  <div>

    <div
      class="row py-3"
    >
      <div
        class="col-sm-12 col-lg-6 d-flex align-items-center"
      >

        <h2>
          Interacciones RRSS
        </h2>

        <button
          class="ml-2 btn btn-success btn-xs "
          type="button"
          @click="downloadExcel"
          :disabled="disabled"
        >
          <i
            class="fa fa-download"
          ></i>

          &nbsp;

          <span
            class="bold"
          >
            Exportar
          </span>
        </button>

      </div>

      <div
        class="col-sm-12 col-lg-6 d-flex align-items-center justify-content-start justify-content-md-end"
      >

        <label
          class="col-form-label mx-2">

          <b>
            Seleccione Rango:
          </b>

        </label>

        <div
          class="form-group m-0">

          <input
            type="date"
            v-model="rangeInit"
            class="form-control"
            :max="today"
            :disabled="disabledRange">

        </div>

        <div
          class="d-none d-lg-block mx-2">

          <div>-</div>

        </div>

        <div
          class="form-group m-0">

          <input
            type="date"
            :max="today"
            v-model="rangeEnd"
            :disabled="disabledRange"
            class="form-control">

        </div>
          <button
              class="ml-2 btn btn-success btn-xs "
              type="button"
              @click="ChangeRange()"
              :disabled="disabled"
          >
              <i
                  class="fa fa-search"
              ></i>

              &nbsp;

              <span
                  class="bold"
              >
            Buscar
          </span>
          </button>
      </div>

    </div>

    <template
      v-if="!loading"
    >

      <!-- CARDS -->
      <div
        class="row"
        v-if="cards.length > 0"
      >

        <div
          class="col-lg-6 col-md-6"
          v-for="(card, index) in cards"
          v-bind:key="index">

          <Card
            :declaration="card"
          />

        </div>

      </div>
      <!--CARDS END -->

      <!-- GRAFICT CHAT-->
      <div
        class="row">

        <div
          class="col-lg-12">

          <div
            class="ibox">

            <div
              class="ibox-title">

              <h5>
                Chatbot
              </h5>

              <div
                class="ibox-tools">

                <a
                  class="collapse-link">

                    <i class="fa fa-chevron-up"></i>

                </a>

              </div>

            </div>

            <div
              class="ibox-content">



              <div
                class="row">

                <div
                  class="col-lg-6">

                  <Bar
                    :height="150"
                    :title="'Flujo de interacciones por horario'"
                    :declaration="ISchedule" />

                </div>

                <div
                  class="col-lg-6 pt-3">

                  <ListPercent
                    :declaration="percent"/>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
      <!-- GRAFICT CHAT END-->

      <div
        class="row">

        <!-- CHATBOT SALUDTOTAL SPECIFIC CHARTS -->

        <div
          class="col-lg-6">

          <div
            class="ibox ">

            <div
              class="ibox-title">

              <h5>
                Gráficos Específicos de Chatbot Salud Total
              </h5>

              <div
                class="ibox-tools">

                <a
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  href="#"
                  aria-expanded="true">

                  <i class="far fa-chart-bar"></i>

                </a>

                <ul
                  class="dropdown-menu
                  dropdown-user"
                  x-placement="top-start"
                  style="position: absolute; top: -80px; left: 26px; will-change: top, left;">

                  <template
                    v-for="(item, i) in tagsGraphics">

                    <li
                    v-bind:key="i"
                      v-if="item.tag =='chat' "
                    >

                      <a
                          class="dropdown-item"
                          @click="changeChart(item)">

                        {{item.value}}

                      </a>

                    </li>

                  </template>

                </ul>

                <a
                  class="collapse-link">

                  <i class="fa fa-chevron-up"></i>

                </a>

              </div>

            </div>

            <div
              class="ibox-content">

              <!-- <Bar
                v-if="showChat == 'usuarios_ciudad'"
                :height="250"
                :declaration="usuariosCiudad" /> -->

              <div
                class="row"
                v-if="showChat == 'usuarios_tipo_documento'" >

                <div
                  class="col-lg-12">

                  <Bar
                    :height="250"
                    :declaration="tipoDocumento" />

                </div>

                <!-- <div
                  class="col-lg-12">

                  <ListPercent
                    :declaration="percentTypeDocument"/>

                </div> -->

              </div>

              <div
                class="row"
                v-if="showChat == 'opciones_menu_principal'" >

                <div
                  id="opciones_menu_principal"
                  class="col-lg-12">

                  <Bar
                      :height="250"
                      :declaration="opcionesMenu" />



                </div>

                <!-- <div
                  class="col-lg-12">

                  <ListPercent
                    :declaration="percentOptionMenu"/>

                </div> -->

              </div>

            </div>

          </div>

        </div>
        <!-- CHATBOT SALUDTOTAL SPECIFIC CHARTS END -->

        <!-- OPTIONS OF EACH SUBMENU -->
        <div
          class="col-lg-6">

          <div
            class="ibox">

            <div
              class="ibox-title">

              <h5>
                % Opciones cada Submenús de cada Menú
              </h5>

              <div
                class="ibox-tools">

                <a
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  href="#"
                  aria-expanded="true">

                  <i class="far fa-chart-bar"></i>

                </a>

                <ul
                  class="dropdown-menu dropdown-user"
                  x-placement="top-start"
                  style="position: absolute; top: -80px; left: 26px; will-change: top, left;">

                  <template
                    v-for="(item, j) in tagsGraphics">

                    <li
                    v-bind:key="j"
                      v-if="item.tag =='submenu' "
                    >
                      <a
                        @click="changeChart(item)"
                        class="dropdown-item">

                        {{item.value}}

                      </a>

                    </li>

                  </template>

                </ul>

                <a
                  class="collapse-link">

                  <i class="fa fa-chevron-up"></i>

                </a>

              </div>

            </div>

            <div
              class="ibox-content">

              <Bar
                v-if="ShowSubmenu == 'informacion_EPS'"
                :height="250"
                :declaration="informacionEPS" />

              <Bar
                v-if="ShowSubmenu == 'coronavirus'"
                :height="250"
                :declaration="coronavirus" />

              <Bar
                v-if="ShowSubmenu == 'tramites'"
                :height="250"
                :declaration="tramites" />

              <Bar
                v-if="ShowSubmenu == 'planes_complementarios'"
                :height="250"
                :declaration="planesComplementarios" />

            </div>

          </div>

        </div>
        <!-- OPTIONS OF EACH SUBMENU END -->
      </div>
    </template>
    <template
      v-else
    >

      <Spinner
        :width="spinnerData.width"
        :height="spinnerData.height"
      />
    </template>




  </div>
</template>
<script>
  import moment from 'moment'
  import Card from '../components/DashboardDinamic/cardComponent.vue';
  import ListPercent from '../components/DashboardDinamic/percentListComponent.vue';
  import Doughnut from '../components/Graphics/Doughnut.vue';
  import Bar from '../components/Graphics/Bar.vue';
  import PolarArea from '../components/Graphics/PolarArea.vue';
  import Spinner from '../components/Element/spinner.vue';

  export default
  {
    name: 'DarboardDinamic',
    components:
    {
      Card,
      ListPercent,
      Doughnut,
      Bar,
      PolarArea,
      Spinner,
    },
    props:{},
    mounted() {
      this.setData();
    },
    data ()
    {
      return {
        spinnerData:{
          width:'3rem',
          height:'3rem'
        },
        timerId:'',
        loading:false,
        loadingFilterDay: false,
        disabledRange:false,
        disabledFilterDay:false,
        disabled:false,
        today:moment().format('YYYY-MM-DD'),
        // rangeInit:moment().subtract(5, 'd').format('YYYY-MM-DD'),
        rangeInit:moment().format('YYYY-MM-DD'),
        rangeEnd:moment().format('YYYY-MM-DD'),
        filterDay:moment().format('YYYY-MM-DD'),
        showChat:'usuarios_tipo_documento',
        ShowSubmenu:'informacion_EPS',
        tagsGraphics:[
          {
            id:'usuarios_ciudad',
            tag:'chat',
            value:'% de usuarios por ciudad'
          },
          {
            id:'usuarios_tipo_documento',
            tag:'chat',
            value:'% de usuarios por tipo de documento'
          },
          {
            id:'opciones_menu_principal',
            tag:'chat',
            value:'% de opciones del menú principal'
          },
          {
            id:'informacion_EPS',
            tag:'submenu',
            value:'Información EPS'
          },
          {
            id:'coronavirus',
            tag:'submenu',
            value:'Coronavirus'
          },
          {
            id:'tramites',
            tag:'submenu',
            value:'Trámites'
          },
          {
            id:'planes_complementarios',
            tag:'submenu',
            value:'Planes Complementarios'
          },

        ],
        cards:[
          {
            tag:{
              class:'label-success',
              title:'Whatsapp'
            },
            title:'Interacciones',
            amount:'0',
            percent:0,
            icon:'fa fa-bolt',
            description:'Total',
          },
          {
            tag:{
              class:'label-info',
              title:'Facebook'
            },
            title:'Interacciones',
            amount:'0',
            percent:0,
            icon:'fa fa-level-up',
            description:'Total',
          },
          // {
          //   tag:{
          //     class:'label-primary',
          //     title:'Whatsapp'
          //   },
          //   title:'Usuarios únicos',
          //   amount:'0',
          //   percent:0,
          //   icon:'fa fa-level-up',
          //   description:'Total',
          // },
          // {
          //   tag:{
          //     class:'label-danger',
          //     title:'Facebook'
          //   },
          //   title:'Usuarios únicos',
          //   amount:'0',
          //   percent:0,
          //   icon:'fa fa-level-down',
          //   description:'Total',
          // },
        ],
        percent:[
          {
            total:'0',
            title:'Tiempo promedio de interacción',
            percent:0,
          },
          {
            total:'0',
            title:'Conversaciones promedio por usuario',
            percent:0
          },
          {
            total:'0',
            title:'Encuestas de satisfacción del bot',
            percent:0
          }
        ],
        ISchedule:{

          labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
          datasets: [
            {
              label:'Whatsapp',
              backgroundColor: '#41B883',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              label:'Facebook',
              backgroundColor: '#0033ff',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          ]
        },
        usuariosCiudad:{
           labels: [
            'Caracas',
            'Valencia',
            'Falcon',
            'Maracay',
            'Maracaibo',
            'Merida',
            'San Cristobal',
            'Trujillo',
            'Amazonas',
            'Margarita',
            'Guarenas',
            'Guatire'
          ],
          datasets: [
            {
              label: 'Ciudades',
              backgroundColor: '#23c5c7',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          ]
        },
        tipoDocumento:{
          labels: ['Rut', 'Pasaporte', 'NIE'],
          datasets: [
            {
              backgroundColor: ['#1e6fd2', '#23c5c7', '#b71a27'],
              data: [0, 0, 0]
            }
          ]
        },
        percentTypeDocument:[
          {
            total:'0',
            title:'Pasaporte',
            percent:0,
          },
          {
            total:'0',
            title:'NIE',
            percent:0
          },
          {
            total:'0',
            title:'RUT',
            percent:0
          }
        ],
        opcionesMenu:{
          labels: [
            'Actualizar datos',
            'Información EPS',
            'Coronavirus',
            'Citas',
            'Trámites',
            'Planes Complementarios',
          ],
          datasets: [
            {
              label: 'Opciones del Menu Principal',
              backgroundColor: ['#55b88247', '#dc654bb5', '#49d9ff80', '#d4150099','#f2ab4e8a', '#df3c8c82'],
              pointBackgroundColor: 'rgba(179,181,198,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(179,181,198,1)',
              data: [0, 0, 0, 0, 0, 0]
            },
          ]
        },
        percentOptionMenu:[
          {
            total:'0',
            title:'Actualizar datos',
            percent:0,
          },
          {
            total:'0',
            title:'Información EPS',
            percent:0
          },
          {
            total:'0',
            title:'Coronavirus',
            percent:0
          },
          {
            total:'0',
            title:'Citas',
            percent:0,
          },
          {
            total:'0',
            title:'Trámites',
            percent:0
          },
          {
            total:'0',
            title:'Planes Complementarios',
            percent:0
          }
        ],
        informacionEPS:{
          labels: [
            'Consulta prioritaria',
            'Medios virtuales',
            'Servicio al cliente',
            'Red de prestación',
            'Entrega medicamentos',
            'Estado de cartera',
          ],
          datasets: [
            {
              label: 'Opciones del Menu Principal',
              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16','#f8ac59', '#e83e8c'],
              pointBackgroundColor: 'rgba(179,181,198,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(179,181,198,1)',
              data: [0, 0, 0, 0, 0, 0]
            },
          ]
        },
        coronavirus:{
          labels: ['Toma de muestra', 'Consultar resultados', 'Certificados', 'Seguimiento vacuna', 'Cita vacunación', 'Reportar Fallecido', 'Otros trámites covid'],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16',  '#E49551', '#00D4FF', '#DD2B17'],
              data: [0, 0, 0, 0, 0, 0, 0]
            }
          ]
        },
        tramites:{
           labels: [
            'Afiliación',
            'Autorizaciones',
            'Incap/licencias',
          ],
          datasets: [
            {
              label: 'Trámites',
              backgroundColor: '#0051c2',
              data: [0, 0, 0]
            }
          ]
        },
        planesComplementarios:{
          labels: [
            'Planes PAC',
            'Afiliación',
            'Pago Moderador',
            'Directorio',
            'Nove Contrato PAC',
            'Autorizaciones PAC',
            'Certificado-Factura',
            'Dudas'
          ],
          datasets: [
            {
              label: 'Opciones del Menu Principal',
              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16','#f8ac59', '#e83e8c', '#10D8FF', '#E47691'],
              pointBackgroundColor: 'rgba(179,181,198,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(179,181,198,1)',
              data: [0, 0, 0, 0, 0, 0]
            },
          ]
        },


      }
    },
    methods:{
      setData()
      {
        this.loading = true;
        let params = {
          fecha_inicio:this.rangeInit,
          fecha_termino:this.rangeEnd,
        }

        axios.get("/admin/reportes/rrss/dashboard_data", { params : params })
        .then(( { data } ) => {

          this.cards = data.card;
          this.percent = data.percent;
          this.ISchedule = data.ischedule;
          // this.percentTypeDocument = data.percentTypeDocument;
          this.tipoDocumento = data.tipoDocumento;
          this.opcionesMenu = data.opcionesMenu;
          this.informacionEPS = data.informacionEPS;
          this.coronavirus = data.coronavirus;
          this.tramites = data.tramites;
          this.planesComplementarios = data.planesComplementarios;
          this.tagsGraphics = data.tagsGraphics;
          this.filterDay = this.rangeEnd;
          this.loading = false;
          this.disabledRange = false;
        })
        .catch((error) => {
          this.loading = false;
          this.disabledRange = false;
            console.log(error);
        });

      },

      changeChart( option )
      {
        if(option.tag === 'chat')
          this.showChat = option.id;

        if(option.tag === 'submenu')
          this.ShowSubmenu = option.id;

      },

      ChangeRange()
      {
        if(this.rangeEnd >= this.rangeInit){
          this.disabledRange = true;
          this.setData();
        }
      },

      buscador()
      {
        this.debounce( this.ChangeRange, 1500 );
      },

      debounce( callback, wait )
      {
        clearTimeout(this.timerId);
        this.trigger(callback , wait);
      },

      trigger( callback , wait )
      {
        this.timerId = setTimeout(() => {
          callback();
        }, wait);
      },

      downloadExcel()
      {
        let params = {
          fecha_inicio:this.rangeInit,
          fecha_termino:this.rangeEnd,
        }
        this.disabled = true;

        axios.post("/admin/reportes/rrss/dashboard_download", params)
        .then(( response ) => {
          this.downloadFile(response, `ReportesDashboard(${this.rangeEnd}|${this.rangeInit}).csv`);
          this.disabled = false;
        })
        .catch((error) => {
          this.disabled = false;
          console.log(error);
        });
      },

      downloadFile(response, filename)
      {
        const anchor    = document.createElement("a");
        anchor.href     = "data:text/csv;charset=utf-8," + encodeURIComponent(response.data);
        anchor.target   = "_blank";
        anchor.download = filename;
        anchor.click();
      },
    }

  }
</script>
